import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { PasswordInput as BasePasswordInput } from '@nucleus-commerce/ui/components/password-input';

/** The shared password input with its eye-toggle labels translated. */
export function PasswordInput(props: ComponentProps<typeof BasePasswordInput>) {
  const { t } = useTranslation('common');
  return (
    <BasePasswordInput showLabel={t('password.show')} hideLabel={t('password.hide')} {...props} />
  );
}
